import { css } from '@adornis/chemistry/directives/css.js';
import { FormField } from '@adornis/formfield/form-field.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import '@chancenwerk/design/components/cr-checkbox.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/fonts.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement anmeldung-component-formfield-consent-eval
 */
@customElement('anmeldung-component-formfield-consent-eval')
export class AnmeldungComponentFormfieldConsentEval extends FormField<boolean> {
  @property({ attribute: false }) public translation = new TranslationController(this);

  override render() {
    return html`
      <cr-flex space="md">
        <cr-flex
          crossaxis-center
          ${css({
            borderRadius: '0 60px',
            overflow: 'hidden',
            border: `${this.spacing.xxs} solid ${this.colors.tone.error}`,
            background: this.colors.tone.error,
          })}
        >
          <cr-h3
            ${css({
              color: this.colors.white,
              padding: this.spacing.md,
            })}
          >
            ${this.translation.translate('consentDeclaration')}
          </cr-h3>
          <cr-flex
            space="md"
            padding="md"
            ${css({
              borderRadius: `0 ${this.spacing.xs}`,
              overflow: 'hidden',
              background: '#F4E2DF',
            })}
          >
            <cr-text ${css({ opacity: '.87' })}>
              <!-- Hiermit erkläre ich mich einverstanden, dass Chancenwerk e.V. zum Zwecke der Evaluierung und
              Qualitätsverbesserung des Lernförderprogramms Befragungen durchführt und dabei personenbezogene Daten von
              mir und meinem Kind erhebt, verarbeitet und speichert. Die Daten werden vertraulich behandelt.<br />
              <br />
              Zum Schutz der personenbezogenen Daten bedient sich Chancenwerk e.V. eines Pseudonymisierungsverfahrens.
              Dabei werden die personenbezogenen Daten unter einer Kennung gespeichert, die sich aus vorgegebenen
              Parametern zusammensetzt, sodass eine namentliche Zuordnung nur noch unter erheblichem Aufwand möglich
              wäre <br />
              Die Abgabe dieser Erklärung ist freiwillig und die Einwilligung kann jederzeit schriftlich gegenüber
              <b>Chancenwerk e.V., Am Markt 18, 44575 Castrop-Rauxel</b> oder per E-Mail an
              <b>evaluation@chancenwerk.org</b>, widerrufen werden. Wenn Sie diese Erklärung nicht abgeben, wird dies
              keine nachteiligen Folgen für Sie haben, insbesondere nicht für die Durchführung des Vertrages. Aus der
              Einwilligung erfolgt keine Pflicht, bei konkreten Befragungen mitzuwirken. Die Teilnahme an konkreten
              Befragungen bleibt für Sie und Ihr Kind freiwillig. <br />
              <br />
              Um eine sinnvolle Evaluierung des Kurserfolgs in zeitlicher Hinsicht zu ermöglichen, werden die Daten für
              einen Zeitraum von fünf Jahren nach der letzten Datenerhebung durch Chancenwerk e.V. gespeichert. Die
              Ergebnisse der Evaluierung dürfen in anonymer Form veröffentlicht werden (z.B. im Jahresbericht oder als
              Zusammenfassung auf der Chancenwerk-Homepage). -->
            </cr-text>
          </cr-flex>
          <!-- <cr-flex horizontal crossaxis-center space="md" padding="md" ${css({ position: 'relative' })}>
            <cr-h4 ${css({ position: 'absolute', right: '100%', color: this.colors.white })}>
              Akzeptieren
            </cr-h4>
            <cr-checkbox
              .value=${this.value.value}
              @click=${() => {
            this.value.next(true);
            const eventDis = new CustomEvent('value-picked', {
              detail: {
                value: true,
              },
            });
            this.dispatchEvent(eventDis);
          }}
            ></cr-checkbox>
            <cr-checkbox
              .value=${this.value.value === false}
              @click=${() => {
            this.value.next(false);
            const eventDis = new CustomEvent('value-picked', {
              detail: {
                value: false,
              },
            });
            this.dispatchEvent(eventDis);
          }}
            ></cr-checkbox>
            <cr-h4 ${css({ position: 'absolute', left: '100%', color: this.colors.white })}> Ablehnen </cr-h4>
          </cr-flex> -->
        </cr-flex>
      </cr-flex>
    `;
  }
}
